import React from "react";
import coin from "../../../assets/images/others/coin.png";
import treasure from "../../../assets/images/others/treasure2.png";
import s from "./style.module.css";

const ScorePanel = ({ LessonPercentage, QuizPercentage }) => {
  const handleCalulate = () => {
    const LessonScore = Math.round(LessonPercentage);
    const QuizScore = Math.round(QuizPercentage);
    const totalScore = LessonScore + QuizScore;
    return totalScore;
  };
  const RenderCoin = () => {
    const percent = handleCalulate();
    let countStar;
    if (percent > 0 && percent <= 60) {
      countStar = 1;
    } else if (percent > 60 && percent < 100) {
      countStar = 2;
    } else if (percent === 100) {
      countStar = 3;
    }
    return (
      <div
        style={{
          width: "40%",
          position: "absolute",
          bottom: -20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {Array(countStar).fill(
          <img style={{ width: "50%", height: "50%" }} src={coin} alt="coin" />
        )}
      </div>
    );
  };
  return (
    <div className={s.scoreContainer}>
      <div className={s.chestContainer}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {RenderCoin()}
        </div>

        <img
          style={{ width: "100%", height: "100%", paddingRight: "25px" }}
          src={treasure}
          alt="treasure"
        />
      </div>
      <div className={s.scoreBarContainer}>
        <span>{handleCalulate()}</span>
      </div>
    </div>
  );
};

export default ScorePanel;
